import { apiRequest, postApiRequest, putApiRequest } from './_tools';

export function fetchPlayables({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/playables?page=${page}&itemsPerPage=${itemsPerPage}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}` +
    `&id=${filter.id || ''}` +
    `&name=${filter.name || ''}` +
    `&platform=${filter.platform}` +
    `&reason=${filter.reason}` +
    `&active=${filter.active}` +
    `&countryCode=${filter.countryCode}`)
    .catch(({ error }) => Promise.reject(error));
}

export function addPlayable(playable) {
  return postApiRequest('/api/playables', playable)
    .catch(({ error }) => Promise.reject(error));
}

export function updatePlayable({ playableId, playable }) {
  return putApiRequest(`/api/playables/${playableId}`, playable);
}



/** WEBPACK FOOTER **
 ** ./js/core/api/playables.js
 **/